// extracted by mini-css-extract-plugin
export default {"questionSelection":"qu1iYR20RuAM6H1e","floatingLabelWrapper":"ybWzlrXtWyaQqzqY","floatingLabel":"eOcKt_FoA7TGIaQD","error":"I9sQfTcMXvRJC_AR","required":"dzELHDCkEcnW_0gO"};